import { Offcanvas } from "react-bootstrap";
import { IoCalendarOutline, IoCameraOutline, IoHomeOutline, IoLockClosed, IoPeople } from "react-icons/io5";
import { isMobile } from "utils/helpers";

export default function OffCanvasResourceSelected({
    show,
    handleClose,
    resourceInfo,
    handleSelectManual,
    handleSelectClient,
    handleSelectLock
}) {

    return (<>
        <Offcanvas 
            placement="bottom"
            className="action-sheet" 
            show={show} 
            onHide={handleClose} 
            style={{ minHeight: 0, maxWidth: 450 }}
        >
            <Offcanvas.Header>
                <div className="offcanvas-title fw500 text-16 text-active py-2">
                    {resourceInfo && resourceInfo.resource.title}
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <ul className="action-button-list">
                    <li onClick={handleSelectManual}>
                        <a className="btn btn-list">
                            <span>
                                <IoCalendarOutline /> <span className='ms-1'>Aggiungi appuntamento manuale</span>
                            </span>
                        </a>
                    </li>
                    <li onClick={() => handleSelectClient('SERVICE')}>
                        <a className="btn btn-list">
                            <span>
                                <IoCameraOutline /> <span className='ms-1'>Aggiungi appuntamento servizio</span>
                            </span>
                        </a>
                    </li>
                    <li onClick={() => handleSelectClient('BUILDING')}>
                        <a className="btn btn-list">
                            <span>
                                <IoHomeOutline /> <span className='ms-1'>Aggiungi appuntamento immobile</span>
                            </span>
                        </a>
                    </li>
                    <li onClick={() => handleSelectClient('GENERIC')}>
                        <a className="btn btn-list">
                            <span>
                                <IoPeople /> <span className='ms-1'>Aggiungi appuntamento personal brand</span>
                            </span>
                        </a>
                    </li>
                    {isMobile() && <li onClick={handleSelectLock}>
                        <a className="btn btn-list">
                            <span>
                                <IoLockClosed /> <span className='ms-1'>Blocca slot orario</span>
                            </span>
                        </a>
                    </li>}
                </ul>
            </Offcanvas.Body>
        </Offcanvas>
    </>);

}